/* Le banc. Un seul role : montrer un traitement a la fois, et savoir
   rejouer son animation — sans quoi la comparaison est impossible.

   Le piege, decouvert a l'essai et non suppose : rejouer une animation impose
   de reposer le HTML d'origine, ce qui DETRUIT les elements que
   l'IntersectionObserver du traitement surveillait. Son script, lui, n'a
   tourne qu'une fois au chargement : les elements neufs ne sont jamais
   observes, la classe qui declenche l'animation n'arrive jamais, et l'image
   reste a opacite zero — invisible pour de bon. C'est ce qui est arrive a
   « Souffle » sur les quatre collections.

   D'ou ce registre : chaque traitement depose sa fonction d'initialisation
   dans window.__anInit, et le banc les rappelle toutes apres chaque remise
   en place. */
window.__anInit = window.__anInit || [];
window.__anDemarrer = function () {
  var racine = document.querySelector('.an');
  if (!racine) return;
  var NOTES = window.__anNotes || {};
  var note = racine.querySelector('#anNote');
  var plus = racine.querySelector('#anPlusC');
  var boutons = racine.querySelectorAll('.an-choix button');

  var copies = [];
  Array.prototype.forEach.call(racine.querySelectorAll('.an-vue'), function (v) {
    copies.push({ el: v, cle: v.getAttribute('data-vue'), html: v.innerHTML });
  });

  function reveiller() {
    (window.__anInit || []).forEach(function (f) { try { f(); } catch (e) { } });
  }

  function rejouer(nom) {
    copies.forEach(function (o) { if (o.cle === nom) o.el.innerHTML = o.html; });
    /* Deux images d'attente : le navigateur doit avoir pris acte du HTML neuf
       avant que les observateurs ne le mesurent, sinon ils le trouvent a une
       taille nulle et ne declenchent rien. */
    requestAnimationFrame(function () { requestAnimationFrame(reveiller); });
  }

  function montrer(nom) {
    Array.prototype.forEach.call(boutons, function (b) {
      b.setAttribute('aria-pressed',
        b.getAttribute('data-t') === nom ? 'true' : 'false');
    });
    Array.prototype.forEach.call(racine.querySelectorAll('.an-vue'), function (v) {
      v.hidden = v.getAttribute('data-vue') !== nom;
    });
    var n = NOTES[nom] || { t: '', p: '' };
    note.innerHTML = n.t; plus.innerHTML = n.p;
    racine.__vue = nom;
    rejouer(nom);
  }

  Array.prototype.forEach.call(boutons, function (b) {
    b.addEventListener('click', function () { montrer(b.getAttribute('data-t')); });
  });
  racine.querySelector('#anRejouer').addEventListener('click', function () {
    rejouer(racine.__vue);
  });
  montrer(racine.querySelector('.an-choix button').getAttribute('data-t'));
};


/* --- Le vernissage --- */
window.__anInit.push(function () { (function(){
  /* LE VERNISSAGE — 14 lignes utiles, aucune dependance.
     Le JS ne fait qu'une chose : armer puis declencher au premier passage
     a l'ecran. Il ne touche a rien en dehors du prefixe vsg-. */

  var scenes = document.querySelectorAll('.vsg[data-vsg]');
  if (!scenes.length) return;

  /* Mouvement reduit : on n'arme rien. L'etat au repos EST l'etat final,
     donc la scene est deja complete et immediate. (Le bloc @media du CSS
     assure la meme chose si la preference change apres coup.) */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Sans IntersectionObserver on ne masque rien : on refuse d'armer une
     animation qu'on ne saurait pas declencher au bon moment. */
  if (!('IntersectionObserver' in window)) return;

  var i;
  for (i = 0; i < scenes.length; i++) scenes[i].classList.add('vsg-pret');

  var oeil = new IntersectionObserver(function(entrees, obs){
    for (var k = 0; k < entrees.length; k++){
      if (!entrees[k].isIntersecting) continue;
      var scene = entrees[k].target;
      obs.unobserve(scene);            /* une seule fois, jamais de rejeu */
      scene.classList.add('vsg-joue');
      /* 780 ms : la derniere image-cle finit a 600 ms. On rend alors les
         couches au navigateur (will-change retire, animations coupees). */
      window.setTimeout(function(s){
        return function(){ s.classList.add('vsg-net'); };
      }(scene), 780);
    }
  }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
  /* La marge negative ne porte QUE sur le bas : elle evite de declencher
     pour un bloc qui pointe a peine sous l'ecran. Une marge negative en
     haut, elle, creait un trou mortel : une scene situee dans les premiers
     pourcents d'une page qui ne defile pas n'intersectait jamais la racine
     retrecie — .vsg-pret restait pose et l'oeuvre restait a opacity:0,
     invisible pour toujours (et le lien, lui, restait cliquable).
     Seuil a 0 : declenche des le premier pixel commun, donc aussi bien pour
     une scene deja visible au chargement que pour une scene plus haute que
     l'ecran, ou un ratio n'atteindrait jamais son seuil. */

  for (i = 0; i < scenes.length; i++) oeil.observe(scenes[i]);
})(); });

/* --- L'encre qui se repand --- */
window.__anInit.push(function () { (function(){
  var scenes = document.querySelectorAll('.enc');
  if(!scenes.length) return;

  // le confort d'abord : si l'utilisateur refuse le mouvement, on ne l'arme jamais
  var doux = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;

  Array.prototype.forEach.call(scenes, function(r){
    if(r.getAttribute('data-enc-pret')) return;      // idempotent : plusieurs sections, un seul script
    r.setAttribute('data-enc-pret','1');

    // sans IntersectionObserver ou en mouvement reduit : etat final tout de suite
    if(doux || !('IntersectionObserver' in window)){ r.classList.add('enc-on'); return; }

    r.classList.add('enc-js');   // arme les etats de depart avant la premiere peinture

    var parti = false;   // un seul depart possible, quelle que soit la voie
    var filet;

    var lance = function(){
      if(parti) return;
      parti = true;
      clearTimeout(filet);
      // will-change est pose ICI et pas a l'armement : un bloc arme mais jamais
      // atteint garderait sinon des couches de compositing pour rien. Deux rAF :
      // le premier laisse le navigateur promouvoir les couches, le second seulement
      // change les transform — pose dans la meme image, will-change ne servirait a rien.
      r.classList.add('enc-prep');
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          r.classList.add('enc-on');
          // 700 ms > la plus longue entree (600 ms) : on rend les couches au navigateur
          setTimeout(function(){ r.classList.add('enc-fini'); }, 700);
        });
      });
    };

    // la tache masque l'image : inutile de la repandre sur du vide,
    // on attend son chargement — mais jamais plus de 900 ms, le client passe avant
    var quandPret = function(){
      var img = r.querySelector('.enc-img') || r.querySelector('.enc-repli-img');
      if(!img || img.complete){ lance(); return; }
      img.addEventListener('load', lance, {once:true});
      img.addEventListener('error', lance, {once:true});
      setTimeout(lance, 900);
    };

    // Declenchement au premier passage a l'ecran, jamais sur le defilement.
    // On observe LE CADRE, pas la section : une section plus haute que l'ecran
    // ne peut jamais atteindre un seuil de 25 %, le cadre si.
    var cible = r.querySelector('.enc-toile') || r;
    var io = new IntersectionObserver(function(entrees){
      for(var i=0;i<entrees.length;i++){
        if(entrees[i].isIntersecting){ io.disconnect(); quandPret(); return; }
      }
    },{threshold:.25,rootMargin:'0px 0px -6% 0px'});
    io.observe(cible);

    // FILET DE SECURITE. Si le cadre n'est jamais atteint — bloc plus bas que
    // la page ne peut defiler, onglet reste en arriere-plan, observateur muet —
    // le titre resterait derriere son volet pour toujours. On DESARME alors :
    // retirer .enc-js remet tout a l'etat final instantanement, sans animation
    // (aucune transition n'est declaree hors de .enc-on), donc sans jouer
    // d'effet hors ecran. Le contenu passe avant l'effet, toujours.
    filet = setTimeout(function(){
      if(parti) return;
      parti = true;
      io.disconnect();
      r.classList.remove('enc-js');
    }, 5000);
  });
})(); });

/* --- La lumière rasante --- */
window.__anInit.push(function () { (function(){
  // On ne touche qu'a nos propres noeuds, et jamais deux fois le meme :
  // une page peut contenir plusieurs blocs, et l'editeur de theme rejoue
  // le script a chaque rendu de section.
  var blocs = [].slice.call(document.querySelectorAll('.lrz-bloc:not([data-lrz])'));
  if (!blocs.length) return;
  blocs.forEach(function(b){ b.setAttribute('data-lrz','1'); });

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Mouvement reduit, ou navigateur sans IntersectionObserver : on ne pose PAS
  // .lrz-js, donc aucun etat de depart invisible n'existe et le bloc s'affiche
  // deja dans son etat final. C'est aussi le filet si ce script ne tourne jamais.
  if (reduit || !('IntersectionObserver' in window)) return;

  blocs.forEach(function(b){ b.classList.add('lrz-js'); });

  function demarre(b){
    b.classList.add('lrz-on');
    // 700 ms : la derniere animation finit a 600 ms. On retire alors will-change
    // et on sort la bande de lumiere de la composition — garder des couches
    // vivantes apres coup, c'est la que les petits telephones payent l'addition.
    setTimeout(function(){ b.classList.add('lrz-fini'); }, 700);
  }

  function dansLEcran(b){
    var r = b.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.top < h * 0.9 && r.bottom > 0;
  }

  // Le bloc deja a l'ecran demarre TOUT DE SUITE, sans attendre le premier
  // rappel de l'observateur : un en-tete de collection est au-dessus de la
  // ligne de flottaison, il ne doit dependre de rien pour exister.
  var aObserver = [];
  blocs.forEach(function(b){ dansLEcran(b) ? demarre(b) : aObserver.push(b); });
  if (!aObserver.length) return;

  // CORRECTION IMPORTANTE — rootMargin ramene a zero.
  // L'ancienne valeur '0px 0px -10% 0px' retrecissait la racine de 10 % en bas.
  // Un bloc situe dans les 10 % inferieurs d'une page trop courte pour defiler
  // davantage n'intersectait alors JAMAIS : demarre() n'etait jamais appele, et
  // la regle ".lrz-bloc.lrz-js .lrz-cadre{opacity:0}" — deja posee — laissait
  // l'oeuvre et le texte invisibles pour toujours. Avec une marge nulle, toute
  // entree a l'ecran declenche, et la regle "rien ne se declenche hors ecran"
  // reste respectee a la lettre.
  var obs = new IntersectionObserver(function(entrees){
    entrees.forEach(function(e){
      if (!e.isIntersecting) return;
      obs.unobserve(e.target);   // une seule fois : jamais de rejeu au defilement
      demarre(e.target);
    });
  }, { threshold: 0, rootMargin: '0px' });

  aObserver.forEach(function(b){ obs.observe(b); });
})(); });

/* --- Le fil de couleur --- */
window.__anInit.push(function () { (function(){
  /* A poser en fin de <body>, sans async : le script doit avoir pose l'etat de
     depart AVANT que l'image ne soit peinte. Charge trop tard, on verrait
     l'oeuvre, puis elle disparaitrait, puis elle reviendrait. */

  /* On ne prend que les scenes pas encore traitees : le bloc peut apparaitre
     plusieurs fois, et le script peut etre charge deux fois par un theme. */
  var scenes = document.querySelectorAll('.flc-scene:not([data-flc])');
  if (!scenes.length) { return; }

  var calme = window.matchMedia('(prefers-reduced-motion: reduce)');
  var i;

  /* Mouvement reduit, ou navigateur sans IntersectionObserver : on passe
     directement a l'etat final. On ne traverse JAMAIS l'etat masque, donc
     aucun risque de laisser du contenu invisible. */
  if (calme.matches || !('IntersectionObserver' in window)) {
    for (i = 0; i < scenes.length; i++) { scenes[i].setAttribute('data-flc', 'fini'); }
    return;
  }

  /* L'etat de depart est pose ici et pas en CSS : si le JS ne s'execute pas,
     la page reste entierement lisible au lieu d'afficher un bloc vide. */
  for (i = 0; i < scenes.length; i++) { scenes[i].setAttribute('data-flc', 'pret'); }

  var io = new IntersectionObserver(function (lots) {
    for (var k = 0; k < lots.length; k++) {
      if (!lots[k].isIntersecting) { continue; }
      var scene = lots[k].target;
      io.unobserve(scene);              /* une seule fois, jamais de boucle */
      scene.setAttribute('data-flc', 'on');
      /* La sequence finit a 920 ms. A 1000 ms on retire will-change et les
         transitions : on ne laisse pas neuf calques de composition ouverts
         pour rien sur un telephone d'entree de gamme. Les valeurs visuelles
         sont identiques entre "on" et "fini", donc rien ne bouge. */
      (function (el) {
        window.setTimeout(function () { el.setAttribute('data-flc', 'fini'); }, 1000);
      })(scene);
    }
  },
  /* CORRECTIF CRITIQUE — threshold etait a 0.2.
     Le ratio d'intersection ne peut jamais depasser hauteur_racine /
     hauteur_element. Des que le bloc est plus HAUT que la racine d'observation
     — portrait extreme sur telephone, zoom texte a 200 %, theme aux interlignes
     genereux — ce ratio reste sous 0,2, le callback n'est JAMAIS appele, et la
     scene reste bloquee sur "pret" : oeuvre, titre, description, vignettes et
     bouton a opacity 0, definitivement. C'est le piege du contenu invisible
     pour toujours, deplace du bloc mouvement-reduit vers l'observateur.
     threshold 0 se declenche des le premier pixel visible, donc toujours ; la
     marge negative de 8 % conserve le meme point de declenchement a l'oeil (le
     haut du bloc franchit 92 % de la hauteur d'ecran) sans jamais dependre de
     la taille du bloc. */
  { threshold: 0, rootMargin: '0px 0px -8% 0px' });

  for (i = 0; i < scenes.length; i++) { io.observe(scenes[i]); }
})(); });

/* --- Le kaléidoscope --- */
window.__anInit.push(function () { (function () {
  'use strict';

  /* Rythme du kaleidoscope. FONDU doit rester egal a la duree de
     transition de .klx-plan dans le CSS, sinon les deux plans se
     croisent de travers. */
  var FONDU = 1100;   /* fondu croise, tres lent */
  var TENUE = 2600;   /* chaque plan tenu, le temps de le regarder */
  var PREMIER = 1400; /* on laisse l'entree se poser avant de bouger */

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var blocs = document.querySelectorAll('.klx-bloc');

  Array.prototype.forEach.call(blocs, function (bloc) {
    if (bloc.getAttribute('data-klx')) { return; }   /* deja arme */
    bloc.setAttribute('data-klx', '1');

    /* Mouvement reduit, ou navigateur sans IntersectionObserver : on
       ne touche a rien. Le HTML est deja dans son etat final, l'image
       de collection est la, entiere, immobile. */
    if (reduit || !('IntersectionObserver' in window)) { return; }

    var plans = bloc.querySelectorAll('.klx-plan');
    var marques = bloc.querySelectorAll('.klx-marque');

    /* On n'arme l'etat "avant" qu'ici, au moment ou on sait qu'on
       saura l'enlever. Si ce script casse, rien n'est jamais cache. */
    bloc.classList.add('klx-anime');

    var etat = { i: 0, t: 0, actif: false, parti: false, vu: false, fini: plans.length < 2 };

    function poser(n) {
      plans[etat.i].classList.remove('klx-plan--on');
      etat.i = n;
      plans[n].classList.add('klx-plan--on');
      for (var k = 0; k < marques.length; k++) {
        marques[k].classList.toggle('klx-marque--on', k <= n);
        marques[k].classList.toggle('klx-marque--pass', k < n);
      }
    }

    function finir() {
      etat.fini = true;
      etat.actif = false;
      clearTimeout(etat.t);
      obs.disconnect();   /* un tour, puis on rend la main pour de bon */
    }

    function suivant() {
      var n = etat.i + 1 >= plans.length ? 0 : etat.i + 1;
      poser(n);
      /* retour au plan 0 : le tour est complet, on se repose sur
         l'affiche de la collection et plus rien ne bougera.
         CORRECTIF : ce dernier delai est range dans etat.t comme les
         autres, sinon un defilement pendant le dernier fondu ne pouvait
         pas l'annuler et la promesse "hors ecran, cout nul" sautait. */
      if (n === 0) { etat.t = setTimeout(finir, FONDU); return; }
      etat.t = setTimeout(suivant, TENUE + FONDU);
    }

    var obs = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        if (entrees[i].isIntersecting) {
          if (!etat.vu) {
            etat.vu = true;
            bloc.classList.add('klx-vu');
            /* l'entree dure 590 ms au pire : on rend les couches GPU
               juste apres, on ne les garde pas en otage */
            setTimeout(function () { bloc.classList.add('klx-pose'); }, 700);
          }
          if (etat.fini) {
            /* CORRECTIF : un seul plan (collection sans image, ou une
               seule oeuvre) — aucun tour ne demarrera jamais, mais
               l'observateur restait attache a vie. On debranche des que
               l'entree est jouee. Le setTimeout de klx-pose deja arme
               s'execute quand meme, disconnect ne l'annule pas. */
            obs.disconnect();
          } else if (!etat.actif) {
            etat.actif = true;
            etat.t = setTimeout(suivant, etat.parti ? TENUE : PREMIER);
            etat.parti = true;
          }
        } else if (!etat.fini) {
          etat.actif = false;
          clearTimeout(etat.t);   /* hors ecran : plus une seule image calculee */
        }
      }
    }, { threshold: 0.2 });

    obs.observe(bloc);
  });
})(); });

/* --- Le mur qui s'ouvre --- */
window.__anInit.push(function () { (function(){
  /* « Le mur qui s'ouvre ». Le CSS decrit la page OUVERTE : sans ce script,
     la collection s'affiche entiere et lisible. C'est ici, et seulement ici,
     qu'on la referme pour avoir quelque chose a ouvrir. */

  var racines = document.querySelectorAll('.mvo');
  if(!racines.length){ return; }

  /* Mouvement refuse : on ne ferme jamais le mur. L'etat final est deja
     celui du HTML, il n'y a donc rien a rendre : on sort. */
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){ return; }

  /* Pas d'IntersectionObserver (navigateur ancien) : plutot que d'ecouter le
     defilement — interdit — on laisse la page ouverte. Zero animation vaut
     mieux qu'une animation qui coute cher. */
  if(!('IntersectionObserver' in window)){ return; }

  /* GARDE-FOU LE PLUS IMPORTANT DU FICHIER.
     Le CSS peint le mur OUVERT ; c'est nous qui le refermons. Si ce script
     s'execute alors que le document est deja entierement charge — injection
     tardive, balise async, `shopify:section:load` dans l'editeur de theme —
     l'en-tete a deja ete peint ouvert. Le refermer maintenant produirait un
     claquement : contenu visible, mur qui se ferme d'un coup, puis rouverture.
     C'est pire que pas d'animation. Dans ce cas on ne touche a rien. */
  if(document.readyState === 'complete'){ return; }

  Array.prototype.forEach.call(racines, function(racine){
    if(racine.dataset.mvoPret === '1'){ return; }   /* idempotent : sections dupliquees, rechargement de theme */
    racine.dataset.mvoPret = '1';

    var secours = 0;

    /* Nettoyage : retire les transitions ET la promotion en calque, et se
       desabonne. Appele par la fin normale, par une annulation, ou par le
       minuteur de secours — dans tous les cas une seule fois utile. */
    function nettoie(){
      clearTimeout(secours);
      racine.classList.remove('mvo--prete');
      racine.classList.remove('mvo--calque');
      racine.removeEventListener('transitionend', surFin);
      racine.removeEventListener('transitioncancel', surFin);
    }

    /* Le vantail est la derniere entree a finir (100 + 490 = 590 ms). */
    function surFin(ev){
      if(ev.propertyName !== 'transform'){ return; }
      if(!ev.target.classList || !ev.target.classList.contains('mvo-vantail')){ return; }
      nettoie();
    }

    function ouvre(){
      /* On promeut les calques UNE IMAGE avant de bouger : c'est le seul
         moment ou will-change sert a quelque chose. Hors de cette fenetre de
         600 ms, aucun calque promu n'existe — y compris si la section est
         restee longtemps sous la ligne de flottaison. */
      racine.classList.add('mvo--calque');
      racine.addEventListener('transitionend', surFin);
      /* transitioncancel : onglet en arriere-plan, section demontee, media
         query qui bascule en plein vol. Sans lui, transitionend ne vient
         jamais et les calques restaient promus a vie. */
      racine.addEventListener('transitioncancel', surFin);
      /* Dernier filet : meme si aucun evenement n'arrive, on nettoie. */
      secours = setTimeout(nettoie, 1200);

      requestAnimationFrame(function(){
        racine.classList.remove('mvo--ferme');
      });
    }

    /* 1. On ferme. Aucune transition n'est encore declaree, la fermeture est
          donc instantanee et invisible. */
    racine.classList.add('mvo--ferme');

    /* 2. Une image plus tard, on declare les transitions. Deux rAF : le
          premier laisse le navigateur peindre l'etat ferme, le second garantit
          que le passage a l'etat ouvert sera bien interpole. */
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        racine.classList.add('mvo--prete');

        /* 3. On n'ouvre qu'a l'entree dans l'ecran, et une seule fois :
              l'observateur se deconnecte des le premier declenchement.
              Le seuil est calcule et non fige : un quart de la section reste
              l'intention, mais une section plus haute que quatre ecrans
              (telephone etroit, titre long, format portrait) ne pourrait
              jamais atteindre 0,25 — le contenu resterait invisible pour
              toujours. On plafonne donc a « une demi-hauteur d'ecran ». */
        var hauteur = racine.offsetHeight || 1;
        var seuil = Math.min(0.25, (window.innerHeight * 0.5) / hauteur);

        var obs = new IntersectionObserver(function(entrees){
          for(var i = 0; i < entrees.length; i++){
            if(!entrees[i].isIntersecting){ continue; }
            obs.disconnect();
            ouvre();
            return;
          }
        }, { threshold: seuil });

        obs.observe(racine);
      });
    });
  });
})(); });

/* --- La signature --- */
window.__anInit.push(function () { (function(){
  /* Une seule responsabilité : décider QUAND la scène se pose.
     Aucune valeur d'animation n'est écrite ici — tout le mouvement vit
     dans le CSS, ce script ne fait que basculer deux classes préfixées. */
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  var blocs  = document.querySelectorAll('.sgn:not(.sgn-on)');
  if (!blocs.length) return;

  function poser(el){
    el.classList.add('sgn-on');
    /* 1 100 ms = fin de la chorégraphie la plus longue (700 ms) plus une
       marge. On retire alors will-change : plus aucune couche promue en
       mémoire graphique une fois la scène immobile. */
    setTimeout(function(){ el.classList.add('sgn-fini'); }, 1100);
  }

  /* Mouvement réduit, ou navigateur sans IntersectionObserver : état final
     immédiat, sans transition (le CSS les a déjà neutralisées). On n'observe
     rien, on ne déclenche rien. */
  if (reduit.matches || !('IntersectionObserver' in window)){
    Array.prototype.forEach.call(blocs, function(el){
      el.classList.add('sgn-on','sgn-fini');
    });
    return;
  }

  /* Jamais d'écouteur de défilement : l'observateur ne réveille le fil
     principal qu'au franchissement du seuil, et se désabonne aussitôt —
     la scène ne rejoue donc jamais, il n'y a aucune boucle.
     CORRIGÉ : on écoute aussi le seuil 0, parce qu'un bloc plus haut que
     4,5 fois la fenêtre ne peut JAMAIS atteindre 22 % de visibilité — le
     titre serait resté sous son rideau pour toujours. Dans ce cas on se
     contente de son entrée à l'écran. */
  var obs = new IntersectionObserver(function(entrees){
    entrees.forEach(function(e){
      if (!e.isIntersecting) return;
      var trop_haut = e.boundingClientRect.height > window.innerHeight * 0.9;
      if (e.intersectionRatio >= 0.22 || trop_haut){
        obs.unobserve(e.target);
        poser(e.target);
      }
    });
  }, { threshold: [0, 0.22], rootMargin: '0px 0px -6% 0px' });

  Array.prototype.forEach.call(blocs, function(el){ obs.observe(el); });
})(); });

/* --- La profondeur --- */
window.__anInit.push(function () { (function(){
  var racines = document.querySelectorAll('.pfd');
  if(!racines.length || !('IntersectionObserver' in window)) return;

  var doux = window.matchMedia('(prefers-reduced-motion: reduce)');

  Array.prototype.forEach.call(racines, function(racine){
    var stage = racine.querySelector('.pfd-stage');
    if(!stage) return;

    /* Mouvement réduit : état final tout de suite, aucun écouteur,
       aucune boucle, aucune couche promue. On ne pose même pas .pfd-anim,
       donc rien n'a jamais été masqué. */
    if(doux.matches){ racine.classList.add('pfd-on'); return; }

    /* On ne masque le contenu QUE maintenant, une fois le script en vie.
       Si le JavaScript échoue, la section reste complète et lisible. */
    racine.classList.add('pfd-anim');

    var MAX_X = 2.2, MAX_Y = 3;   /* degrés : au-delà, ça donne le vertige */
    var DERIVE = 17000;           /* la respiration d'accueil ne joue qu'une fois */
    var cx = 0, cy = 0;           /* cible, en fraction de l'amplitude */
    var x = 0, y = 0, vx = 0, vy = 0;
    var visible = false, tourne = false, pris = false;
    var derive = 0, tPrec = 0;

    function borne(v){ return v < -1 ? -1 : (v > 1 ? 1 : v); }

    function boucle(t){
      if(!visible){ tourne = false; stage.style.willChange = ''; return; }
      var dt = tPrec ? Math.min(50, t - tPrec) : 16;
      tPrec = t;

      /* Respiration d'accueil : une lente oscillation (période ~17 s), puis
         plus jamais, même si on repasse devant la section. Une boucle infinie
         sur un en-tête vu partout finit par agacer plus qu'elle ne séduit. */
      if(!pris && derive < DERIVE){
        derive += dt;
        if(derive >= DERIVE){ cx = 0; cy = 0; }
        else {
          cy = Math.sin(derive / 2700) * 0.34;
          cx = Math.sin(derive / 3900) * 0.22;
        }
      }

      /* Ressort amorti : rejoint la cible sans rebond. Le rebond, à cette
         échelle, ne se lit pas comme du ressort mais comme un tremblement. */
      vx += (cx - x) * 0.085; vx *= 0.80; x += vx;
      vy += (cy - y) * 0.085; vy *= 0.80; y += vy;

      /* UNE seule écriture de style par image, sur UN seul élément.
         Les couches enfants portent un translateZ figé : c'est le
         compositeur qui calcule leur décalage, et l'ombre part à l'inverse
         gratuitement puisqu'elle est en Z négatif. */
      stage.style.transform =
        'rotateX(' + (x * MAX_X).toFixed(3) + 'deg) rotateY(' + (y * MAX_Y).toFixed(3) + 'deg)';

      var pose = Math.abs(cx - x) < 0.0015 && Math.abs(cy - y) < 0.0015
              && Math.abs(vx) < 0.0015 && Math.abs(vy) < 0.0015;

      if(pose){
        /* Arrivé au repos, on rend la main : plus de rAF, plus de will-change.
           Sur une page laissée ouverte, le coût retombe à zéro. */
        tourne = false;
        stage.style.willChange = '';
        /* On n'efface la transformation que si la cible est le centre,
           sinon on ferait sauter l'œuvre alors que le curseur est posé
           quelque part sur le côté. */
        if(Math.abs(cx) < 0.002 && Math.abs(cy) < 0.002) stage.style.transform = '';
        return;
      }
      requestAnimationFrame(boucle);
    }

    function reveiller(){
      if(tourne || !visible) return;
      tourne = true;
      tPrec = 0;
      stage.style.willChange = 'transform';  /* promu seulement pendant le mouvement */
      requestAnimationFrame(boucle);
    }

    /* --- La souris : l'œuvre se tourne VERS le curseur.
       Le bord le plus proche du pointeur vient vers le lecteur. --- */
    racine.addEventListener('pointermove', function(ev){
      if(ev.pointerType === 'touch') return;  /* au doigt, la main cache l'œuvre */
      /* Lecture de géométrie sans risque de reflow forcé : les seules
         écritures de ce module sont des transform, qui ne salissent
         jamais la mise en page. */
      var r = racine.getBoundingClientRect();
      /* Le rect vide sort AVANT de marquer la prise en main : sinon on
         tuait la respiration d'accueil sans rien mettre à la place. */
      if(!r.width || !r.height) return;
      pris = true;
      cy = borne(((ev.clientX - r.left) / r.width  - 0.5) * -2);
      cx = borne(((ev.clientY - r.top)  / r.height - 0.5) *  2);
      reveiller();
    }, {passive:true});

    racine.addEventListener('pointerleave', function(){
      cx = 0; cy = 0; reveiller();
    }, {passive:true});

    /* --- Le gyroscope : l'œuvre reste posée dans l'espace pendant que
       le téléphone bouge autour d'elle.
       Sur iOS il faudrait une permission déclenchée par un geste : on
       n'ouvre pas une popup système pour une inclinaison décorative,
       donc on s'abstient et on s'en tient à l'entrée. --- */
    if(window.DeviceOrientationEvent &&
       typeof window.DeviceOrientationEvent.requestPermission !== 'function'){
      var base = null;
      window.addEventListener('deviceorientation', function(ev){
        if(!visible || ev.beta == null || ev.gamma == null) return;
        /* Première lecture = position de référence : l'effet part de zéro,
           quelle que soit la façon dont le téléphone est tenu. */
        if(base === null){ base = {b: ev.beta, g: ev.gamma}; return; }
        pris = true;
        cx = borne((base.b - ev.beta)  / 14);
        cy = borne((base.g - ev.gamma) / 14);
        reveiller();
      }, {passive:true});
    }

    /* --- Déclenchement au premier passage à l'écran, et mise en veille
       dès que la section sort du champ. Jamais d'écouteur de défilement. --- */
    var io = new IntersectionObserver(function(entrees){
      for(var i = 0; i < entrees.length; i++){
        visible = entrees[i].isIntersecting;
        if(visible){
          racine.classList.add('pfd-on');
          reveiller();
        } else {
          /* Hors champ, le curseur n'est plus dessus : on remet la cible au
             centre. Sans ça, un pointerleave survenu hors écran laissait la
             scène figée de travers, et on la retrouvait penchée sans raison
             visible en remontant dessus. Le ressort la recale en douceur. */
          cx = 0; cy = 0;
        }
      }
    }, {threshold: 0.12});
    io.observe(racine);
  });
})(); });

/* --- Le grain de la toile --- */
window.__anInit.push(function () { (function(){
  "use strict";

  // Rien a corriger ici : le script passe l'audit tel quel. Il est reproduit
  // en entier pour que le bloc reste livrable d'un seul tenant.
  // Un seul point de vigilance a l'integration, qui ne se regle pas dans le
  // script : POSER CETTE IIFE EN LIGNE JUSTE APRES LA SECTION. Si elle est
  // chargee tard (defer, ou en fin de body), la section est peinte dans son
  // etat FINAL avant que .gtl-anim n'arrive, et l'on voit un saut vers l'etat
  // de depart. La specification evite l'animation a l'envers — transform et
  // transition sont poses dans le meme recalcul de style, donc la transition
  // ne demarre pas — mais le saut, lui, se voit.

  var scenes = document.querySelectorAll(".gtl-scene");
  if(!scenes.length) return;

  // Deux sorties immediates. Dans les deux cas on ne touche a rien : le HTML
  // est deja dans son etat final, donc « ne rien faire » = tout est visible.
  if(!("IntersectionObserver" in window)) return;
  if(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var io = new IntersectionObserver(function(entrees){
    for(var i=0;i<entrees.length;i++){
      if(!entrees[i].isIntersecting) continue;
      io.unobserve(entrees[i].target);   // une seule fois, jamais de rejeu
      lever(entrees[i].target);
    }
  }, { threshold:.14, rootMargin:"0px 0px -6% 0px" });

  function lever(scene){
    var img = scene.querySelector(".gtl-oeuvre");

    var partir = function(){
      if(scene.classList.contains("gtl-vu")) return;
      scene.classList.add("gtl-vu");
      window.setTimeout(function(){
        // Fin de sequence : on relache les calques promus et on supprime la
        // lumiere rasante, qui n'a servi qu'une fois et ne doit plus couter.
        scene.classList.add("gtl-fini");
        var lueur = scene.querySelector(".gtl-lueur");
        if(lueur && lueur.parentNode) lueur.parentNode.removeChild(lueur);
      }, 640);
    };

    // « L'oeuvre monte du grain » n'a de sens que si l'oeuvre est arrivee.
    // On l'attend, mais jamais plus de 450 ms : l'animation ne fait pas attendre.
    if(img && !img.complete){
      img.addEventListener("load", partir, { once:true });
      img.addEventListener("error", partir, { once:true });
      window.setTimeout(partir, 450);
    }else{
      partir();
    }
  }

  for(var j=0;j<scenes.length;j++){
    // Deja depassee au chargement (retour arriere, ancre) : pas d'animation
    // fantome dans le dos de l'utilisateur, on laisse l'etat final.
    if(scenes[j].getBoundingClientRect().bottom < 0) continue;
    scenes[j].classList.add("gtl-anim");   // pose l'etat de depart : le grain seul
    io.observe(scenes[j]);
  }
})(); });

/* --- Souffle --- */
window.__anInit.push(function () { (function () {
  var scenes = document.querySelectorAll('.sfl-scene');
  if (!scenes.length) return;

  var doux = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Deux sorties immediates, pour la meme raison : ne jamais laisser un
  // visiteur devant du contenu invisible.
  //  - mouvement reduit : la feuille de style a deja fige l'etat final ;
  //  - pas d'IntersectionObserver : on laisse les animations jouer au
  //    chargement plutot que de les mettre en pause sans jamais les relancer.
  if (doux.matches || !('IntersectionObserver' in window)) return;

  var obs = new IntersectionObserver(function (entrees) {
    for (var i = 0; i < entrees.length; i++) {
      // Un seul geste : on met en marche a l'entree, en pause a la sortie.
      // Rien ne tourne hors de l'ecran, et le souffle reprend ou il en etait
      // au lieu de repartir a zero.
      entrees[i].target.classList.toggle('sfl-on', entrees[i].isIntersecting);
    }
  }, { threshold: 0.2 });

  // PASSE 1 — on SUPPRIME les animations (animation:none), on ne les met pas
  // en pause. C'est le point critique : le navigateur les a demarrees des
  // l'analyse du CSS, donc avant ce script. Une simple mise en pause figerait
  // les elements la ou ils en sont — et si le script arrive apres 600 ms, une
  // scene sous la ligne de flottaison serait figee a son image FINALE : le
  // visiteur descendrait jusqu'a elle et ne verrait jamais l'entree jouer.
  Array.prototype.forEach.call(scenes, function (scene) {
    scene.classList.add('sfl-fige');
  });

  // Un seul recalcul force pour toutes les scenes a la fois : c'est lui qui
  // valide la suppression et permet aux animations de renaitre a l'image zero.
  void document.body.offsetWidth;

  // PASSE 2 — on relance et on gele dans le MEME changement de style :
  // l'animation est recreee puis immediatement mise en pause a l'image zero,
  // sans qu'une seule image ne soit jouee entre les deux.
  Array.prototype.forEach.call(scenes, function (scene) {
    scene.classList.add('sfl-arme');
    scene.classList.remove('sfl-fige');

    scene.addEventListener('animationend', function (ev) {
      // 580 ms : la lumiere rasante est la derniere animation d'ENTREE. La
      // plaque et la bande n'ont plus rien a composer, on leur rend leur
      // couche tout de suite au lieu d'attendre la fin du souffle — sinon
      // deux couches de grande surface restaient promues 37 secondes.
      if (ev.animationName === 'sfl-rasant') {
        scene.classList.add('sfl-fini');
        return;
      }

      // 37 s : le souffle a fait ses cinq cycles et rend la main. La scene est
      // definitivement au repos : dernier will-change retire, plus d'observation.
      if (ev.animationName === 'sfl-souffle') {
        scene.classList.add('sfl-repos');
        obs.unobserve(scene);
      }
    });

    obs.observe(scene);
  });
})(); });

/* Tout est enregistre : le banc peut ouvrir. */
window.__anDemarrer();
